import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../../hooks/useAuth'
import { canUseSalesEnablement } from '../../utils/adminAccess'

interface SalesEnablementRouteProps {
  children: React.ReactNode
}

export const SalesEnablementRoute: React.FC<SalesEnablementRouteProps> = ({ children }) => {
  const { user, isAuthenticated } = useAuth()

  if (!isAuthenticated) {
    return <Navigate to="/auth/login" replace />
  }

  if (!canUseSalesEnablement(user)) {
    return <Navigate to="/dashboard" replace />
  }

  return <>{children}</>
}
